import {newSpecPage} from '@stencil/core/testing';
import {JoyCollapse} from '../collapse';
import {JoyCollapseItem} from '../../JoyCollapseItem/collapse-item';

it('should open all items', async () => {
    const page = await newSpecPage({
        components: [JoyCollapse, JoyCollapseItem],
        html: `
            <joy-collapse>
                <joy-collapse-item class="first">
                    <p slot="collapse-summary">This is a summary</p>
                    <p slot="collapse-detail">This is a detail content</p>
                </joy-collapse-item>
                <joy-collapse-item class="second">
                    <p slot="collapse-summary">This is another summary</p>
                    <p slot="collapse-detail">This is another detail content</p>
                </joy-collapse-item>
            </joy-collapse>
        `,
    });

    // Events do not bubble up here cause it's plugged in a div element, that is not actually clickable. jest limitation.
    // Then we need to specifically select the right element
    const first: HTMLJoyCollapseItemElement = page.body.querySelector('joy-collapse-item.first')!;
    const second: HTMLJoyCollapseItemElement = page.body.querySelector('joy-collapse-item.second')!;

    const firstItem: HTMLElement = first.shadowRoot?.querySelector('.joy-collapse-item__summary')!;
    const secondItem: HTMLElement = second?.shadowRoot?.querySelector('.joy-collapse-item__summary')!;

    firstItem.click();
    await page.waitForChanges();
    expect(first.open).toBe(true);
    expect(second.open).toBe(false);

    secondItem.click();
    await page.waitForChanges();
    expect(first.open).toBe(true);
    expect(second.open).toBe(true);
});

it('should open only one item at a time (accordion mode)', async () => {
    const page = await newSpecPage({
        components: [JoyCollapse, JoyCollapseItem],
        html: `
            <joy-collapse accordion>
                <joy-collapse-item class="first">
                    <p slot="collapse-summary">This is a summary</p>
                    <p slot="collapse-detail">This is a detail content</p>
                </joy-collapse-item>
                <joy-collapse-item class="second">
                    <p slot="collapse-summary">This is another summary</p>
                    <p slot="collapse-detail">This is another detail content</p>
                </joy-collapse-item>
            </joy-collapse>
        `,
    });

    // Events do not bubble up here cause it's plugged in a div element, that is not actually clickable. jest limitation.
    // Then we need to specifically select the right element
    const first: HTMLJoyCollapseItemElement = page.body.querySelector('joy-collapse-item.first')!;
    const second: HTMLJoyCollapseItemElement = page.body.querySelector('joy-collapse-item.second')!;

    const firstItem: HTMLElement = first.shadowRoot?.querySelector('.joy-collapse-item__summary')!;
    const secondItem: HTMLElement = second?.shadowRoot?.querySelector('.joy-collapse-item__summary')!;

    firstItem.click();
    await page.waitForChanges();
    expect(first.open).toBe(true);
    expect(second.open).toBe(false);

    secondItem.click();
    await page.waitForChanges();
    expect(first.open).toBe(false);
    expect(second.open).toBe(true);
});

it('should open an item using "toggle" public method', async () => {
    const page = await newSpecPage({
        components: [JoyCollapse, JoyCollapseItem],
        html: `
            <joy-collapse>
                <joy-collapse-item class="first">
                    <p slot="collapse-summary">This is a summary</p>
                    <p slot="collapse-detail">This is a detail content</p>
                </joy-collapse-item>
                <joy-collapse-item class="second">
                    <p slot="collapse-summary">This is another summary</p>
                    <p slot="collapse-detail">This is another detail content</p>
                </joy-collapse-item>
            </joy-collapse>
        `,
    });

    const first: HTMLJoyCollapseItemElement = page.body.querySelector('joy-collapse-item.first')!;

    await first?.toggle();
    await page.waitForChanges();
    expect(first.open).toBe(true);

    await first?.toggle({open: false});
    await page.waitForChanges();
    expect(first.open).toBe(false);
});
